import logoImg from "@/assets/dairect-logo-wordmark.svg";

export default function Logo({ onClick }: { onClick?(): void }) {
  return (
    <div
      onClick={onClick}
      id="logo"
      className="flex cursor-pointer items-center gap-2"
    >
      <img src={logoImg} alt="Takyon logo" />
      <div className="w-[1px] h-6 bg-white rounded-full" />
      <p className="font-[200] text-lg text-white">a Takyon Brand</p>
    </div>
  );
}
